// extracted by mini-css-extract-plugin
export default {"tooltip":"cU-z","arrow":"dU-z"};